import { Provider } from '../provider/provider.model';
import { EntityTypeEnum } from '../../enums/entity-type.enum';

export class Entity {
    /** Identificador unico da Entidade */
    Id?: number;
    /** Provider de conexão */
    Provider?: Provider = new Provider();
    /** Instrução SQL */
    Query?: string;
    /** Descrição da Entidade */
    Description?: string;
    /** É uma Lista de Informação */
    EntityType?: EntityTypeEnum;
    /** Versão */
    Revision?: number;
    /** Quantidade de Registros por pagina */
    AmountByPage?: number;
}
